import { Text } from "@chakra-ui/react";
// import "../app.css";

export default function Barriers(){
    return(
        <>
        <Text className="text-format" style={{whiteSpace:"pre-line", alignContent:"center"}} >
        There are many ways we can be held back, put down or aside,
        <br/>
        by ourselves,
        <br/>
        by others,
        <br/>
        or by everything around and inside us.
        <br/>
        <br/>
        By now we know,
        <br/>
        the way forward is through.
        <br/>
        Finding your footing,<br/>
        one step at a time.<br/>
        <br/>
        Only by accumulation,<br/>
        error and trial,<br/>
        we can overcome our barriers.
        
        </Text>
        </>
    )
}